<div id="bodyReportContainer" fxLayout="column" class="container" *ngIf="{mediaParams: mediaParams$ | async} as data">
  <div *ngIf="selectedElement != null" fxFlex="none" fxLayout="column" class="selected-element-container">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span class="mat-title">Selected Damage</span>
      <div class="body-report-damage-media-buttons" fxLayout="row">
        <sha-media-gallery-dialog-button
          [media$]="mediaStateService.getBodyReportMedia(selectedElement.id, inspectionService.workOrderId ? inspectionService.workOrderId : route.snapshot.queryParams?.workOrderId)">
        </sha-media-gallery-dialog-button>
        <sha-media-upload-input class="ml-4"
          [params]="mediaStateService.buildMediaParams(data.mediaParams,{damageId: selectedElement.id,caption: selectedElement.comment, customerFacing: false, galleryDescription: selectedElement.type})">
        </sha-media-upload-input>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
      <mat-form-field fxFlex="100" appearance="fill">
        <mat-label>Comment</mat-label>
        <input matInput [(ngModel)]="selectedElement.comment">
      </mat-form-field>

      <div fxLayout="column" fxFlex="100">
        <mat-label style="margin-bottom: 16px;">Severity</mat-label>
        <mat-slider color="primary" [max]="3" [min]="1" [step]="1" [thumbLabel]="true" [tickInterval]="30"
          [(ngModel)]="selectedElement.severity">
        </mat-slider>
        <span style="transform: translate3d(0,6px,0) scale(.75); margin: -25px 0 16px -20px">
          {{formatSeverity(selectedElement)}}
        </span>
      </div>
    </div>
    <div fxLayoutAlign="center center" style="padding-bottom: 8px;">
      <button mat-raised-button color="warn" (click)="delete(selectedElement)">Delete</button>
    </div>
    <div fxLayoutAlign="end end">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-button color="primary" (click)="close()">Confirm</button>
    </div>
  </div>
</div>